import { render, staticRenderFns } from "./IconCards.vue?vue&type=template&id=1a017b27&"
import script from "./IconCards.vue?vue&type=script&lang=js&"
export * from "./IconCards.vue?vue&type=script&lang=js&"
import style0 from "./IconCards.vue?vue&type=style&index=0&id=1a017b27&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports